module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-96627848.png";